import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, Button } from '@mui/material'
import { getCityList, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { cargoServiceTypes } from '../rateMatrixConstants'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { clickElement, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import AddIcon from '@mui/icons-material/Add';
import CityPairTable from './CityPairTable'
import CityPairModal from './CityPairModal'
import CityPairCancelPop from './CityPairCancelPop'
import { getCityPairRateMatrixData, getFocApprConsTypeData, updateCityPairRateMatrixData, cancelCityPairStatus, getCityPairRateMatrixExcelData } from '../../../../../store/generalSetting/GSAction'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import CityPairExcelTable from './CityPairExcelTable'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'

const CityPairRateMatrix = (props) => {
    const { data, updateModal, updateAlertError, getCityList, getFocApprConsTypeData, getCityPairRateMatrixData, updateCityPairRateMatrixData, cancelCityPairStatus, getCityPairRateMatrixExcelData } = props
    const { common, generalSettingReducer } = data
    const { loginData, showModal, modalType, cityList } = common
    const { focApprConsTypeData, serviceTypeListAll, serviceTypeListAll2 } = generalSettingReducer
    const [showAddNewPage, setShowAddNewPage] = useState(false)
    const [serviceTypeOpt, setServiceTypeOpt] = useState([])
    const [consTypeList, setConsTypeList] = useState([])
    const [srcCityList, setSrcCityList] = useState([])
    const [destCityList, setDestCityList] = useState([])
    const [tableData, setTableData] = useState([])
    const [reportData, setReportData] = useState([])
    const [editData, setEditData] = useState([])
    const [filters, setFilters] = useState({
        cargoServiceType: cargoServiceTypes[0],
        serviceType: '',
        consignmentType: '',
        sourceCity: '',
        destinationCity: ''
    })
    const [cancelPop, setCancelPop] = useState(false)
    const [cancelData, setCancelData] = useState(null)
    const [isSave, setIsSave] = useState(false)
    const [msg, setMsg] = useState('City-Pair Rate Matrix\nUpdated Successfully!')
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const [totalNoOfRows, setTotalNoOfRows] = useState(0)
    const [cityPairExcel, setCityPairExcel] = useState([])
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }
    useEffect(()=>{
        focusElemnt('Service_Type_Select')
    },[])
    useEffect(() => {
        if (cityList?.length > 0) {
            setSrcCityList(cityList)
            let selectedCity = cityList?.filter((item) => item?.CityID === loginData?.intBranchCityID)
            setFilters((prev) => ({
                ...prev,
                sourceCity: selectedCity[0]
            }))
        }
    }, [cityList])
    useEffect(() => {
        if (filters?.sourceCity !== '' || filters?.sourceCity !== undefined) {
            let destList = cityList?.filter((item) => item?.CityID !== filters?.sourceCity?.CityID)
            destList.unshift({ CityID: 0, CityName: 'All' });
            setDestCityList(destList)
            setFilters((prev) => ({
                ...prev,
                destinationCity: destList[0]
            }))
        }
    }, [filters?.sourceCity])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let obj = {
                intConsignmentSubTypeID: 0,
                intCompanyID: loginData?.intCompanyID,
                intConsignmentTypeID: 0,
                strSubType: "",
                intIsActive: 1,
                intIsDeleted: 0
            }
            getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)
            getCityList(loginData, true, 24 * 60 * 60 * 1000)
        }
    }, [loginData])
    useEffect(() => {
        if (serviceTypeListAll?.length > 0) {
            let data = serviceTypeListAll?.filter((val) => serviceTypeListAll2?.length > 0 ? serviceTypeListAll2?.[0]?.CargoServiceTypeID === 0 ? val?.ServiceTypeID === 2 : true : true)
            if (Number(serviceTypeListAll2?.[0]?.CargoServiceTypeID) === 1) {
                setFilters((prev) => ({
                    ...prev,
                    cargoServiceType: cargoServiceTypes[1]
                }))
            } else {
                setFilters((prev) => ({
                    ...prev,
                    cargoServiceType: cargoServiceTypes[0]
                }))
            }
            setServiceTypeOpt(data)
            setFilters((prev) => ({
                ...prev,
                serviceType: data[0]
            }))
        } else {
            setServiceTypeOpt([])
            setFilters((prev) => ({
                ...prev,
                serviceType: ''
            }))

        }
    }, [serviceTypeListAll, serviceTypeListAll2])
    useEffect(() => {
        if (focApprConsTypeData?.length > 0) {
            let newData = []
            // let newData = [{ id: 0, name: 'All' }]
            focApprConsTypeData.map(function (obj) {
                newData.push({
                    id: obj.ConsignmentSubTypeID,
                    name: obj.SubType,
                })
            })
            newData = removeDuplicatesFromArray(newData, `id`)
            newData.sort((a, b) => a.name.localeCompare(b.name))
            setConsTypeList(newData)
            setFilters((prev) => ({
                ...prev,
                consignmentType: newData[0]
            }))
        } else {
            setConsTypeList([])
        }
    }, [focApprConsTypeData])
    const showCityPairRateUploadPopup = () => {
        const data = {
            loginData,
            headText: 'Add New City Pair Rate Matrix',
            cancelData, 
            setCancelData,
            setMsg,
            setIsSave,
            cancelPop, setCancelPop
        }
        const methods = {
            updateModal,
            updateAlertError,
            setShowAddNewPage,
            // showCancelPop: () => {
            //     setCancelPop(true)
            // }
        }
        return <CityPairModal data={data} methods={methods} />
    }

    // const showCancelPopup = () => {
    //     const data = {
    //         loginData,
    //         headText: 'Cancellation Remarks',
    //         cancelData, 
    //         setCancelData
    //     }
    //     const methods = {
    //         updateModal: () => {
    //             setCancelPop(false)
    //         },
    //         updateAlertError,
    //         cancelApi
    //     }
    //     return <CityPairCancelPop data={data} methods={methods} />
    // }
   useEffect(()=>{
    if (!isEmpty(loginData)) {
        let body = {
          CompanyID: loginData?.intCompanyID,
          FromCityID:loginData?.intBranchCityID,
          ToCityID:0,
          ConsignmentID: 0,
          Mode:1,
          RateType: 'Consignment',
          PartyID:0,
          ExpressParcelBooking:0,
          ServiceTypeID: 2,
          PageNo:page+1,
          NoOfRows:rowsPerPage
        }
        getCityPairRateMatrixData(body).then((res) => {
            if (res.status === 'Success') {
              let data = res?.Data?.Table
              let rows = res?.Data?.Table3?.[0]?.totalRows
              setTableData(data)
              setReportData(data)
              setTotalNoOfRows(rows)
            } else {
                setTableData([])
              setReportData([])
              setTotalNoOfRows(0)
            //   updateAlertError({ show: true, msg: 'No Data', nextId: '' })
            }
          }).catch((error) => {
            setTableData([])
            setReportData([])
            setTotalNoOfRows(0)
            updateAlertError({ show: true, msg: error, nextId: '' })
          })
      }
   },[loginData])
    const handleSearch = (page=0, rowsPerPage=10) => {
        if (filters?.cargoServiceType === '') {
            updateAlertError({ show: true, msg: 'Please Select Cargo Service Type', success: false, nextId: `` })
          } else if (filters?.serviceType === '') {
            updateAlertError({ show: true, msg: 'Please Select Service Type', success: false, nextId: `` })
          } else if (filters?.consignmentType === '') {
            updateAlertError({ show: true, msg: 'Please Select Consignment Type', success: false, nextId: `` })
          } else if (filters?.sourceCity === '') {
            updateAlertError({ show: true, msg: 'Please Select Source City', success: false, nextId: `` })
          }else if (filters?.destinationCity === '') {
            updateAlertError({ show: true, msg: 'Please Select Destination City', success: false, nextId: `` })
          }else {
            let body = {
              CompanyID: loginData?.intCompanyID,
              FromCityID:filters?.sourceCity?.CityID,
              ToCityID:filters?.destinationCity?.CityID,
              ConsignmentID: filters?.consignmentType?.id,
              Mode:1,
              RateType: 'Consignment',
              PartyID:0,
              ExpressParcelBooking:0,
              ServiceTypeID: filters?.serviceType?.ServiceTypeID,
              PageNo:page+1,
              NoOfRows:rowsPerPage
            }
            getCityPairRateMatrixData(body).then((res) => {
                if (res.status === 'Success') {
                  let data = res?.Data?.Table
                  let rows = res?.Data?.Table3?.[0]?.totalRows
                  setTableData(data)
                  setReportData(data)
              setTotalNoOfRows(rows)

                } else {
                    setTableData([])
                  setReportData([])
                  setTotalNoOfRows(0)
                  updateAlertError({ show: true, msg: 'No Data', nextId: '' })

                }
            }).catch((error) => {
                setTableData([])
                setReportData([])
                setTotalNoOfRows(0)
                updateAlertError({ show: true, msg: error, nextId: '' })
            })
        }
    }
    const handleSave = () => {
        if (editData?.length === 0) {
            updateAlertError('Please enter the data to be updated')
        } else {
            const body = {
                CompanyID: loginData?.intCompanyID,
                FromCityID: filters?.sourceCity?.CityID,
                ConsignmentSubTypeID: filters?.consignmentType?.id,
                UserID: loginData?.intUserID,
                BranchID: loginData?.intBranchID,
                ServiceTypeID: filters?.serviceType?.ServiceTypeID,
                ETADays: editData?.map(row => row?.ETADays).join('^'),
                ToCityIDs: editData?.map(row => row?.ToCityID).join('^'),
                RateIDs: editData?.map(row => row?.RateID).join('^'),
                Rates: editData?.map(row => row?.Rate).join('^'),
                LocalRates: editData?.map(row => row?.LocalRate).join('^'),
                MinFreight: editData?.map(row => row?.MinFreight).join('^'),
            }
            updateCityPairRateMatrixData(body).then((res) => {
                if (res.status === 'Success') {
                    setIsSave(true)
                } else {
                    updateAlertError({ show: true, msg: 'No Data', nextId: '' })
                }
            }).catch((error) => {
                updateAlertError({ show: true, msg: error, nextId: '' })
            })
        }
    }
    const handleCloseSuccessModal = () => {
        // loadServiceType();
        // focusElemnt('kgKmCargoServiceType')
        setIsSave(false);
        setCancelPop(false);
    }

    useEffect(() => {
        if (cityPairExcel.length > 0) {
            clickElement('xls-buttons');
        }
    }, [cityPairExcel])
    const handleCityPairExcel = async () => {
        let body = {
            CompanyID: loginData?.intCompanyID,
            FromCityID: filters?.sourceCity?.CityID,
            ToCityID: filters?.destinationCity?.CityID,
            ConsignmentID: 0,
            ServiceTypeID: filters?.serviceType?.ServiceTypeID,
        };

        try {
            const res = await getCityPairRateMatrixExcelData(body);
            if (res.status === 'Success') {
                let data = res?.Data?.Table;
                setCityPairExcel(data);

            } else {
                setCityPairExcel([]);
            }
        } catch (error) {
            setCityPairExcel([]);
            updateAlertError({ show: true, msg: error, nextId: '' });
        }
    };
    return (
        <>
            {!showAddNewPage && <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '5px 0' }}>
                <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', paddingLeft: '0px', paddingRight: '0px' }} className="reportButtons">
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={'Cargo_Service_Type'}
                            label={'Cargo Service Type'}
                            data={cargoServiceTypes || []}
                            defaultvalue={filters?.cargoServiceType?.name || ''}
                            value={filters?.cargoServiceType?.name || ''}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    cargoServiceType: val
                                }))
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    cargoServiceType: ''
                                }))
                            }}
                            disabled={true}
                            idKey={`id`}
                            dataKey={`name`}
                            nextId={`Service_Type_Select`}
                            prevId={``}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={'Service_Type_Select'}
                            label={'Service Type'}
                            data={serviceTypeOpt || []}
                            defaultvalue={filters?.serviceType?.ServiceType || ''}
                            value={filters?.serviceType?.ServiceType || ''}
                            width="100%"
                            searchPlaceholder={'Search Consignment Type'}
                            dataKey={`ServiceType`}
                            idKey={`ServiceTypeID`}
                            listWidth="200px"
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    serviceType: val
                                }))
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    serviceType: ''
                                }))
                            }}
                            nextId={'Consignment_Type'}
                            prevId={`Cargo_Service_Type`}
                            onSelResetVal={true}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={'Consignment_Type'}
                            label={'Consignment Type'}
                            data={consTypeList || []}
                            defaultvalue={filters?.consignmentType?.name || ''}
                            value={filters?.consignmentType?.name || ''}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    consignmentType: val
                                }))
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    consignmentType: ''
                                }))
                            }}
                            searchPlaceholder={'Search Consignment Type'}
                            dataKey={`name`}
                            idKey={`id`}
                            nextId={`Source_City`}
                            prevId={`Service_Type_Select`}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={'Source_City'}
                            label={'Source City'}
                            data={srcCityList || []}
                            defaultvalue={filters?.sourceCity?.CityName || ''}
                            value={filters?.sourceCity?.CityName || ''}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    sourceCity: val
                                }))
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    sourceCity: ''
                                }))
                            }}
                            onSelResetVal={true}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            nextId={`destination_City`}
                            prevId={`Consignment_Type`}
                        />
                    </Item>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            id={'destination_City'}
                            label={'Destination City'}
                            data={destCityList || []}
                            defaultvalue={filters?.destinationCity?.CityName || ''}
                            value={filters?.destinationCity?.CityName || ''}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    destinationCity: val
                                }))
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    destinationCity: ''
                                }))
                            }}
                            onSelResetVal={true}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            nextId={`load_Btn`}
                            prevId={`Source_City`}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            onKeyDown={(e) => navigation3(e, 'cityPairSave_btn', 'destination_City', () => { })}
                            id={'load_Btn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn btn-primary"
                            onClick={() => { handleSearch(page, rowsPerPage)}}
                        >
                            Load
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="outlined"
                            onKeyDown={(e) => navigation3(e, 'AddNewCityPair_Btn', 'load_Btn', () => { })}
                            id={'cityPairSave_btn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn cancel-btn"
                            onClick={() => { handleSave() }}
                        >
                            SAVE
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="outlined"
                            onKeyDown={(e) => navigation3(e, 'Service_Type_Select', 'cityPairSave_btn', () => { })}
                            id={'AddNewCityPair_Btn'}
                            sx={{ width: '280px', paddingY: '6px !important' }}
                            className="btn cancel-btn"
                            onClick={() => {
                                setShowAddNewPage(true)
                                // updateModal(true, 'city_pair_rate_upload')
                            }}
                            startIcon={<AddIcon />}
                        >
                            Add NEW CITY Pair RATES
                        </Button>
                    </Item>
                    <Box >
                        <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                            onClick={(e) => { handleCityPairExcel() }}
                            // onKeyDown={(e) => {
                            //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                            // }}
                            style={{ width: '100%' }}
                        >
                            EXCEL
                        </Button>
                        <ReactHtmlTableToExcel
                            id="xls-buttons"
                            table="cityPairExelTbl"
                            filename={'City Pair Rate Matrix'}
                            sheet="sheet 1"
                            buttonText=" EXCEL"
                            className="excel-button"
                        />
                    </Box>
                </Box>
            </Box>}
            {!showAddNewPage && <CityPairTable tableData={tableData} setTableData={setTableData} reportData={reportData} filters={filters} setFilters={setFilters} 
            editData={editData} setEditData={setEditData} handleSearch={handleSearch} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}
            totalNoOfRows={totalNoOfRows}
            />}
            {cityPairExcel && cityPairExcel?.length > 0 && <CityPairExcelTable tableData={cityPairExcel} setTableData={setTableData} reportData={reportData} filters={filters} setFilters={setFilters}
                editData={editData} setEditData={setEditData} handleSearch={handleSearch}
                totalNoOfRows={totalNoOfRows} loginData={loginData}
            />}
            {/* {showAddNewPage && <CityPairModal />} */}
            {showAddNewPage && showCityPairRateUploadPopup()}
            {/* {cancelPop ? showCancelPopup() : null} */}
            <SuccessAndErrorModal handleClose={() => { handleCloseSuccessModal() }} open={isSave} title={msg} modalStyle={modalStyle} />
        </>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError, getCityList, getFocApprConsTypeData, getCityPairRateMatrixData, updateCityPairRateMatrixData, cancelCityPairStatus, getCityPairRateMatrixExcelData }
export default connect(mapStateToProps, mapDispatchToProps)(CityPairRateMatrix)